import find from 'lodash/find';
// FIXME: Remove oldUrl when we no longer depend on it

export const OFFICES = {
  id: 'offices',
  url: 'offices',
  oldUrl: 'offices',
  marketing: 'offices',
  displayText: 'Offices',
  longDisplayText: 'Offices',
  sentenceDisplayText: 'Offices',
  pdpTitle: 'Office',
  iconName: 'offices',
};

export const RETAIL = {
  id: 'retail',
  url: 'retail',
  oldUrl: 'retail',
  marketing: 'retail',
  displayText: 'Retail',
  longDisplayText: 'Shop & Retail',
  sentenceDisplayText: 'Shop & Retail Property',
  pdpTitle: 'Shop & Retail Property',
  iconName: 'retail',
};

export const INDUSTRIAL_WAREHOUSE = {
  id: 'industrial warehouse',
  url: 'industrial-warehouse',
  oldUrl: 'industrial+warehouse',
  marketing: 'industrial_warehouse',
  displayText: 'Industrial/Warehouse',
  longDisplayText: 'Warehouse, Factory & Industrial',
  sentenceDisplayText: 'Warehouse, Factory & Industrial Property',
  pdpTitle: 'Industrial & Warehouse Property',
  iconName: 'industrial',
};

export const SHOWROOMS_BULKY_GOODS = {
  id: 'showrooms bulky goods',
  url: 'showrooms-bulky-goods',
  oldUrl: 'showrooms+bulky+goods',
  marketing: 'showrooms_bulky_goods',
  displayText: 'Showrooms/Bulky Goods',
  longDisplayText: 'Showrooms & Bulky Goods',
  sentenceDisplayText: 'Showrooms & Bulky Goods Property',
  pdpTitle: 'Showroom & Bulky Goods',
  iconName: 'showrooms',
};

export const LAND_DEVELOPMENT = {
  id: 'land development',
  url: 'land-development',
  oldUrl: 'land+development',
  marketing: 'land_development',
  displayText: 'Land/Development',
  longDisplayText: 'Development Sites & Land',
  sentenceDisplayText: 'Development Sites & Land',
  pdpTitle: 'Development Site & Land',
  iconName: 'landDevelopment',
};

export const HOTEL_LEISURE = {
  id: 'hotel leisure',
  url: 'hotel-leisure',
  oldUrl: 'hotel+leisure',
  marketing: 'hotel_leisure',
  displayText: 'Hotel/Leisure',
  longDisplayText: 'Hotel & Leisure',
  sentenceDisplayText: 'Hotel & Leisure Property',
  pdpTitle: 'Hotel & Leisure Property',
  iconName: 'hotel',
};

export const MEDICAL_CONSULTING = {
  id: 'medical consulting',
  url: 'medical-consulting',
  oldUrl: 'medical+consulting',
  marketing: 'medical_consulting',
  displayText: 'Medical/Consulting',
  longDisplayText: 'Medical & Consulting',
  sentenceDisplayText: 'Medical & Consulting Property',
  pdpTitle: 'Medical & Consulting Property',
  iconName: 'medical',
};

export const COMMERCIAL_FARMING = {
  id: 'commercial farming',
  url: 'commercial-farming',
  oldUrl: 'commercial+farming',
  marketing: 'commercial_farming',
  displayText: 'Commercial Farming',
  longDisplayText: 'Commercial Farming & Rural',
  sentenceDisplayText: 'Commercial Farming & Rural Property',
  pdpTitle: 'Commercial Farming & Rural Property',
  iconName: 'commercialFarming',
};

export const OTHER = {
  id: 'other',
  url: 'other',
  oldUrl: 'other',
  marketing: 'other',
  displayText: 'Other',
  longDisplayText: 'Other',
  sentenceDisplayText: 'Other Property',
  pdpTitle: 'Other Property',
  iconName: 'other',
};

export const allPropertyTypes = [
  OFFICES,
  RETAIL,
  INDUSTRIAL_WAREHOUSE,
  SHOWROOMS_BULKY_GOODS,
  LAND_DEVELOPMENT,
  HOTEL_LEISURE,
  MEDICAL_CONSULTING,
  COMMERCIAL_FARMING,
  OTHER,
];

export const propertyTypesForSelectElement = allPropertyTypes.map(propertyType => ({
  value: propertyType.id,
  label: propertyType.displayText,
}));

export const parseUrlPropertyType = propertyTypeUrl => find(allPropertyTypes, { url: propertyTypeUrl });

export const getPropertyTypeFromId = propertyTypeId => find(allPropertyTypes, { id: propertyTypeId });

export const getPropertyTypeFromDisplayText = displayText => find(allPropertyTypes, { displayText });

export const hasOnePropertyType = propertyTypes => propertyTypes.length === 1;
